import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { BannersConfigModel } from '../../../models/section-configuration.model';

@Component({
    selector: 'banners-configuration',
    templateUrl: 'banners-configuration.component.html',
    styleUrls: ['banners-configuration.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BannersConfigurationComponent implements OnInit {
  @Input() bannersConfig: BannersConfigModel;
  @Input() sectionConfigId: string;
  @Input() parentFormGroup: FormGroup;
  @Input() isSubmitted: boolean;

  bannersConfigForm: FormGroup;
  expanded: boolean = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  addControls(): void {
    this.bannersConfigForm = this.fb.group({});
    this.parentFormGroup.addControl('bannersConfig', this.bannersConfigForm);
  }
}
